// Admin allowlist — duplicate this list in backend/app.py (ADMIN_EMAILS).
// Keep lowercase; comparisons are case-insensitive.
export const ADMIN_EMAILS = [
  "tkarol48@gmail.com",
  "tyler@birdiebus.com",
];

export function isAdminEmail(email) {
  if (!email) return false;
  const normalized = String(email).trim().toLowerCase();
  return ADMIN_EMAILS.some((e) => e.toLowerCase() === normalized);
}
